// Save login data
export const loginUser = (data) => {
  localStorage.setItem("token", data.token);
  localStorage.setItem("user", JSON.stringify(data.user));
  localStorage.setItem("roles", JSON.stringify(data.roles || []));
  localStorage.setItem("permissions", JSON.stringify(data.permissions || []));
};

// Logout
export const logoutUser = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("roles");
  localStorage.removeItem("permissions");
};

// Get logged-in user
export const getUser = () => {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
};

// Get token
export const getToken = () => {
  return localStorage.getItem("token");
};

// Auth check
export const isLoggedIn = () => {
  return !!getToken();
};

// Get roles
export const getRoles = () => {
  return JSON.parse(localStorage.getItem("roles") || "[]");
};

// Get permissions
export const getPermissions = () => {
  return JSON.parse(localStorage.getItem("permissions") || "[]");
};

// Role check
export const hasRole = (role) => {
  const roles = getRoles();

  if (roles.includes("admin")) return true;

  return roles.includes(role);
};

// Permission check
export const hasPermission = (permission) => {
  const permissions = getPermissions();

  return permissions.includes(permission);
};

// Any permission check
export const hasAnyPermission = (permissionList = []) => {
  const permissions = getPermissions();

  return permissionList.some((permission) =>
    permissions.includes(permission)
  );
};